import { CancelOutlined } from '@mui/icons-material';
import { Alert } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React from 'react';
import { useSelector } from 'react-redux';

import { hasRight } from '#app/Common/UserCommon';
import ContentViewComponent from '#app/Component/ContentViewComponent';
import { getRoutePathname } from '#app/Handler/RouteHandler';
import { StateType } from '#app/Store';
import Confirmation from '#app/View/InventoryManagement/Inventory/DepositInventory/components/Confirmation';
import List from '#app/View/InventoryManagement/Inventory/DepositInventory/components/List';
import Search from '#app/View/InventoryManagement/Inventory/DepositInventory/components/Search';
import useInventory from '#app/View/InventoryManagement/Inventory/DepositInventory/hooks/useInventory';

const DepositInventory: React.FC = () => {
  const authenticationReducer = useSelector((state: StateType) => state.AuthenticationReducer);
  const { data, setFilters, filters, ...props } = useInventory();

  return (
    <ContentViewComponent
      breadcrumbs={{
        title: 'Inventaire',
        context: 'Gestion des stocks',
        links: [
          {
            path: authenticationReducer.shopSelected
              ? getRoutePathname('shop_sales_list_today', { shopId: authenticationReducer.shopSelected })
              : getRoutePathname('inventory_management_inventory_list'),
            label: 'Liste des inventaires',
          },
        ],
      }}
    >
      <Search filters={filters} handleSearch={(data) => setFilters(data)} />
      <Alert severity="info" style={{ marginBottom: 16 }}>
        <strong>Modification :</strong> modifiez directement les champs <strong>Quantité</strong> et{' '}
        <strong>Emplacement de stockage</strong> en cliquant dans les cellules du tableau.
        <br />
        La sauvegarde est automatique dès que vous validez la saisie (clic en dehors ou touche <kbd>Entrée</kbd> pour
        passé la cellule suivante).
        <Grid container alignItems="center" gap={1}>
          <CancelOutlined color="error" fontSize="small" /> =&gt; Permet d'annuler la saisie
        </Grid>
      </Alert>
      <List data={data} {...props} />
      {(hasRight(authenticationReducer, 'ROLE_INVENTORY_MANAGEMENT_INVENTORY') ||
        hasRight(authenticationReducer, 'ROLE_INVENTORY_MANAGEMENT_INVENTORY_VALIDATED')) && (
        <Confirmation activeFilterStock={() => setFilters({ withStock: true })} />
      )}
    </ContentViewComponent>
  );
};

export default DepositInventory;
